
import { selectLangObj } from '../../../reducers/langReducer.js';
import { useDispatch, useSelector } from 'react-redux';

import { selectFamilyDetails, selectLoadingFamilyDetails, setShowDialog, selectFamilyDetailsRbr, selectShowFamilyDetailsDialog } from '../../../reducers/familyDetailsReducer.js';
import { selectNotes, selectLoadingNotes, setTip, selectNotesTip } from '../../../reducers/notesReducer.js';

import { fetchFamilyDetails } from '../../../fetch/fetchFamilyDetails.js';
import { fetchNotes } from '../../../fetch/fetchNotes.js';
import { XCircleIcon } from '@heroicons/react/24/solid';
import { useEffect } from 'react';

import DetailsDialog from '../DetailsDialog.js';
import FamilyDetails from './FamilyDetails.js';

function FamilyDetailsDialog() {

  const dispatch = useDispatch();

  const rbr = useSelector(selectFamilyDetailsRbr);

  const tip = useSelector(selectNotesTip);
  var showDialog = useSelector(selectShowFamilyDetailsDialog);
  var details = useSelector(selectFamilyDetails);
  var notes = useSelector(selectNotes);

  useEffect(() => {
    if (showDialog) {
      dispatch(fetchFamilyDetails(rbr));
      dispatch(setTip("К"));
    }
  },
    [showDialog, rbr]);
     useEffect(() => {
    if (showDialog) {
      dispatch(fetchNotes({ rbr, tip }));
    }
  },
    [details]);






  function setShow(value) {
    dispatch(setShowDialog(value));
  }


  return (

    <DetailsDialog show={showDialog} error={!details} notes={notes} details={details} titleElement={(details && ((details.prezime||"") + (details.imeOca ? " (" + details.imeOca + ") " : " ") + (details.ime||"")))} setShowDialog={setShow} >

      <FamilyDetails details={details}></FamilyDetails>

    </DetailsDialog>

  );
}

export default FamilyDetailsDialog;
